import { useContext, useEffect, useMemo, useState } from "react";
import { LinkedPersonInfo } from "../../../generated/data-contracts";
import { IAxiosError, api } from "../../../utils";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";
import { NoDataPage } from "../../shared/error/NoDataPage";
import { LinkedPersonsListItem } from "./LinkedPersonsListItem";

export function LinkedPersonsList() {
  const [loading, setLoading] = useState<boolean>(true);
  const [linkedPersons, setLinkedPersons] = useState<LinkedPersonInfo[]>([]);
  const [error, setError] = useState<IAxiosError>();

  const { ctxRightsHolder } = useContext(AvisContext);

  useEffect(() => {
    if (!ctxRightsHolder?.rightsHolderId) return;

    api
      .rightsHoldersGetRightsHolderFullRigthsDelegates(
        ctxRightsHolder.rightsHolderId,
      )
      .then((res) => setLinkedPersons(res.data))
      .catch(setError)
      .finally(() => setLoading(false));
  }, [ctxRightsHolder?.rightsHolderId]);

  const renderContent = useMemo(() => {
    if (!linkedPersons || linkedPersons?.length === 0) {
      return <NoDataPage />;
    }

    return (
      <div className="avis-primary-text">
        <ul>
          {linkedPersons.map((item) => {
            return <LinkedPersonsListItem key={item.id} {...item} />;
          })}
        </ul>
      </div>
    );
  }, [linkedPersons]);

  return (
    <ErrorLoadingDataHoc error={error} loading={loading}>
      {renderContent}
    </ErrorLoadingDataHoc>
  );
}
